import {Form, InputGroup} from "react-bootstrap";
import Select from "react-select";
import baseTheme from "../shared/baseTheme";
import parse from "html-react-parser";
import styled from "styled-components";
import {useEffect, useState} from "react";
import {getTheme} from "../shared/themeUtils";

const SelectionGroup = styled.div`
  position: relative;
  margin-bottom: ${getTheme("space.2")};
  .select-label {
    text-align: left;
    font-size: ${getTheme("fontSizes.xSmall")};
    color: ${getTheme("colors.secondaryFont")};
    opacity: .7;
  }

  .react-select {
    width: 100%;
    text-align: left;
  }

  .floating-label {
    position: absolute;
    top: 15px;
    left: 10px;
    font-size: 14px;
    color: #999;
    pointer-events: none;
    transition: all 0.3s ease;
    z-index: 2;
  }

  .floating-label.active {
    top: 7px;
    font-size: 12px;
  }
`

type CustomSelectProps = {
  selectRef?: any,
  id: string
  label: string,
  options: any[],
  value: any,
  setValueFn: any,
  errorMsg?: string[],
  menuPlacement?: any
}

const CustomSelect = (props: CustomSelectProps) => {
  const [isFocusedOrHasValue, setIsFocusedOrHasValue] = useState(false);

  useEffect(() => {
    if (props.value) {
      setIsFocusedOrHasValue(true)
    }
  }, [props])

  return (
    <SelectionGroup>
      <InputGroup>
        <label className={`floating-label ${isFocusedOrHasValue ? 'active' : ''}`}
               htmlFor={props.id}
               onClick={() => props.selectRef.current.focus()}>
          {props.label}
        </label>
        <Select openMenuOnFocus={true}
                ref={props.selectRef}
                id={props.id}
                className="react-select"
                menuPlacement={props.menuPlacement ? props.menuPlacement : "bottom"}
                value={props.value}
                onChange={(event) => props.setValueFn(event)}
                onFocus={() => setIsFocusedOrHasValue(true)}
                onBlur={() => setIsFocusedOrHasValue(props.value)}
                placeholder={""}
                options={props.options}
                styles={{
                  control: (baseStyles, state): any => ({
                    ...baseStyles,
                    minHeight: "55px",
                    zIndex: 1,
                    borderTopLeftRadius: "0px",
                    borderBottomLeftRadius: "0px",
                    boxShadow: "none",
                    "&:hover": {
                      borderColor: props.errorMsg ? "#dc3545" : baseTheme.colors.border,
                    },
                    outline: "none",
                    borderColor: props.errorMsg ? "#dc3545" : baseTheme.colors.border
                  }),
                  menu: (provided): any => ({
                    ...provided,
                    zIndex: 3, // Ensure the options menu appears above the label
                  }),
                  valueContainer: (provided): any => ({
                    ...provided,
                    top: "8px"
                  })
                }}
        />
      </InputGroup>
      <div>
        {props.errorMsg && props.errorMsg.map((msg: string) => {
          return (
            <Form.Control.Feedback style={{display: "block", textAlign: "left"}}
                                   key={"countryCode"}
                                   type={"invalid"}>{parse(msg)}</Form.Control.Feedback>
          )
        })}
      </div>
    </SelectionGroup>
  )
}

export default CustomSelect;